<template>
  <div class="performance-infomation">
    <content-block style="padding-bottom: 0;">
      <el-tabs v-model="activeName">
        <el-tab-pane label="寄修单" name="sendRepair"/>
        <el-tab-pane label="备用机" name="backup"/>
      </el-tabs>
    </content-block>
    <content-block style="padding: 0;">
      <SendRepairOrder v-if="activeName === 'sendRepair'" :code="code" :cooperationLedgerId="cooperationLedgerId" />
      <SpareMachine v-if="activeName === 'backup'" :code="code" :cooperationLedgerId="cooperationLedgerId" />
    </content-block>
  </div>
</template>
<script>
export default {
  components: {
    SpareMachine: () => import('./backupDevice'),
    SendRepairOrder: () => import('./sendRepair'),
  },
  props: {
    code: {
      type: [String, Number],
      default: '',
    },
    cooperationLedgerId: {
      type: String,
      default: '',
    },
  },
  data () {
    return {
      activeName: 'sendRepair',
    };
  },
};
</script>
<style lang="scss" scoped>
.performance-infomation {
  /deep/.el-tabs__header {
    margin-bottom: 0;
    padding-left: 15px;
    padding-right: 15px;
  }
}
</style>
